const pickDefined = (obj) =>
    Object.fromEntries(
      Object.entries(obj).filter(([key, v]) => {
        if (v === undefined || v === null || v === "") return false;
        return !new Set(["role", "userRole", "id", "_id", "userId", "doctorId", "medecinId", "patientId", "uuid", "pgId"]).has(String(key));
      })
    );
  
  export default function mapUserUpdatePayload(values = {}, current = {}) {
    return pickDefined({
      firstName: values.firstName ?? current.firstName,
      lastName:  values.lastName  ?? current.lastName,
      email:     values.email     ?? current.email,
      gender:    values.gender    ?? current.gender,
      birthdate: values.birthdate ?? current.birthdate,
      phone:     values.phone     ?? current.phone,
    });
  }
  